"use strict";

!function () {
  //!function() : IIFE = Immediately Invoked Function Expression
  // Il ! nega il risultato della funzione. Ma siccome il risultato non viene usato, la negazione serve solo come trucco sintattico per far funzionare l'esecuzione immediata.

  var html = document.getElementsByTagName("html")[0];

  // Valori di default
  var defaultConfig = {
    theme: "light",
    layout: {
      mode: "fluid"
    },
    topbar: {
      color: "dark"
    },
    menu: {
      color: "light"
    },
    sidenav: {
      size: "condensed"
    }
  };

  // 1. Legge attributi HTML (prioritari)
  var config = {
    theme: html.getAttribute("data-bs-theme") || defaultConfig.theme,
    layout: {
      mode: html.getAttribute("data-layout-mode") || defaultConfig.layout.mode
    },
    topbar: {
      color: html.getAttribute("data-topbar-color") || defaultConfig.topbar.color
    },
    menu: {
      color: html.getAttribute("data-menu-color") || defaultConfig.menu.color
    },
    sidenav: {
      size: html.getAttribute("data-sidenav-size") || defaultConfig.sidenav.size
    }
  };

  // 2. Permetti override da sessionStorage SOLO se non vuoi forzare da HTML, altrimenti commenta questa parte
  var saved = sessionStorage.getItem("__MANAGER_CONFIG__");
  if (saved) {
    /** SYLVIA: RECUPERO DATI DA MANAGER_CONFIG*/
    try {
      var _fromStorage$layout, _fromStorage$topbar, _fromStorage$menu, _fromStorage$sidenav;
      var fromStorage = JSON.parse(saved);
      config.theme = fromStorage.theme || config.theme;
      config.layout.mode = ((_fromStorage$layout = fromStorage.layout) === null || _fromStorage$layout === void 0 ? void 0 : _fromStorage$layout.mode) || config.layout.mode;
      config.topbar.color = ((_fromStorage$topbar = fromStorage.topbar) === null || _fromStorage$topbar === void 0 ? void 0 : _fromStorage$topbar.color) || config.topbar.color;
      config.menu.color = ((_fromStorage$menu = fromStorage.menu) === null || _fromStorage$menu === void 0 ? void 0 : _fromStorage$menu.color) || config.menu.color;
      config.sidenav.size = ((_fromStorage$sidenav = fromStorage.sidenav) === null || _fromStorage$sidenav === void 0 ? void 0 : _fromStorage$sidenav.size) || config.sidenav.size;
    } catch (e) {
      console.warn("Errore nel parsing del config salvato", e);
    }
  }

  // 3. Imposta il config globale
  window.defaultConfig = JSON.parse(JSON.stringify(config));
  /*console.log("CONFIG:", JSON.stringify(config, null, 2));*/
  window.config = config;

  // 4. Applica al DOM
  if (window.innerWidth <= 1140) {
    html.setAttribute("data-sidenav-size", "full");
    html.setAttribute("data-layout-mode", "condensed");

    //console.log("%c[Sidenav Debug]", "color: #0bf; font-weight: bold;");
    //console.log("InnerWidth:", window.innerWidth);
    //console.log("Sidenav size impostata:", "full (perch� larghezza finestra <= 1140)");
  } else {
    html.setAttribute("data-sidenav-size", config.sidenav.size);
    html.setAttribute("data-layout-mode", config.layout.mode);

    //console.log("%c[Sidenav Debug]", "color: #0bf; font-weight: bold;");
    //console.log("InnerWidth:", window.innerWidth);
    //console.log("Sidenav size impostata da config:", config.sidenav.size);
  }
  html.setAttribute("data-bs-theme", config.theme);
  html.setAttribute("data-menu-color", config.menu.color);
  html.setAttribute("data-topbar-color", config.topbar.color);
}();